// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".section{padding:0 25px}.section .second-title{padding-top:80px}.section .second-title.white h2,.section .second-title.white h4{color:#fff}.section .second-title.white .underline::after{background:#fff}\n", ""]);
// Exports
module.exports = exports;
